import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient, type UseMutationOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import type {ChecklistDto, UpdateChecklistResponseData} from '../../types'
import {HrocChecklistsQueryKey} from '../../types'

type ChecklistUpdateParams = {
  id: string
  plantId: string
}

type ChecklistUpdateOptions = UseMutationOptions<
  UpdateChecklistResponseData,
  AxiosError,
  ChecklistDto['data']
>

export const useChecklistUpdate = (
  {id, plantId}: ChecklistUpdateParams,
  options?: ChecklistUpdateOptions
) => {
  const queryClient = useQueryClient()
  const path = `/hroc-checklists/api/${plantId}/checklists/${id}`
  const {onSuccess, onError, ...restOptions} = options ?? {}

  return useMutation<UpdateChecklistResponseData, AxiosError, ChecklistDto['data']>({
    mutationFn: async (checklistData) => {
      const response = await ApiClient.axiosInstance.patch<UpdateChecklistResponseData>(
        path,
        checklistData
      )
      return response.data
    },
    onSuccess: async (data, variables, context, mutation) => {
      await queryClient.invalidateQueries({
        queryKey: [HrocChecklistsQueryKey.Checklists, plantId, id]
      })
      await onSuccess?.(data, variables, context, mutation)
    },
    onError: async (error, variables, context, mutation) => {
      await onError?.(error, variables, context, mutation)
    },
    ...restOptions
  })
}
